import httpService from '@Utils/httpService';

const baseUrl = 'api/AppProjects';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
};
